import { render, staticRenderFns } from "./invasion-statistics.vue?vue&type=template&id=a5d191de&scoped=true&lang=pug&"
import script from "./invasion-statistics.vue?vue&type=script&lang=js&"
export * from "./invasion-statistics.vue?vue&type=script&lang=js&"
import style0 from "./invasion-statistics.vue?vue&type=style&index=0&id=a5d191de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d191de",
  null
  
)

export default component.exports